import { render, staticRenderFns } from "./MadeOrder.vue?vue&type=template&id=546c733c&scoped=true&"
import script from "./MadeOrder.vue?vue&type=script&lang=js&"
export * from "./MadeOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546c733c",
  null
  
)

export default component.exports